import { useToast } from "@chakra-ui/toast";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { put } from "util/axiosLib";

const Toggle2FA = ({ userData, token }) => {
  const history = useHistory();
  const toast = useToast();
  const { twoFactor } = userData;
  const [state, setState] = useState(twoFactor);

  const URL = `${process.env.REACT_APP_API_ENDPOINT}/auth/2fa/turnOffTwoFa`;

  const handleToggleSwitch = async () => {
    setState(!state);

    if (state === false) {
      setTimeout(() => {
        history.push("/2fagenerate?btm");
      }, 2000);
    } else {
      // disable 2fa
      const disable = {};
      try {
        const response = await put(URL, disable, {
          authorization: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        });

        if (response) {
          setState(false);

          toast({
            position: "bottom-right",
            description: "You have successfully disabled 2FA Authentication",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
        }
      } catch (error) {
        setState(true);

        toast({
          position: "bottom-right",
          description: error.error,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <div>
      <div className="asr-sb-single">
        <div className="asr-sb-desc">
          <p>Two-factor Authentication </p>
        </div>

        <div className="asr-sb-arrow">
          <label className="switch-toggle">
            <input
              checked={state}
              onChange={handleToggleSwitch}
              type="checkbox"
              name="2fa"
            />
            <span className="slider-toggle round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Toggle2FA;
